// extracted by mini-css-extract-plugin
export default {"popupGenPremiumAIResponse":"PopupGenPremiumAIResponse_popupGenPremiumAIResponse__CMZqi","linearLoader":"PopupGenPremiumAIResponse_linearLoader__PiBkW"};